import { de, enGB, enUS } from 'date-fns/locale';
import i18next from 'i18next';

let _locale: Locale = enGB;
export const getLocale = () => _locale;

export enum AppLanguage {
  'en-us' = 'en-us',
  'en' = 'en',
  'de' = 'de',
}

/*
 * Sets language (locale) for date-time functions.
 */
export function setLanguage(language: AppLanguage) {
  _locale = getLanguageDefaultLocale(language);
}

function getLanguageDefaultLocale(language: AppLanguage): Locale {
  switch (language) {
    case AppLanguage.en:
      return enGB;
    case AppLanguage['en-us']:
      return enUS;
    case AppLanguage.de:
      return de;

    default:
      assertNeverDontThrow(language);
      return enGB;
  }
}

export function assertNeverDontThrow(x: never): never {
  return x;
}

export function localize(value: string) {
  return i18next.t(value as any, { ns: 'data-block-fields' });
}
